import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  reportsSharedModelService,
} from 'app/services';
import {
  alerts,
  actionIcon,
  viewReport,
} from 'app/components/global';

import directive from './report-instance.directive';
import controller from './report-instance.controller';

import editReportInstanceCommentDialog from '../../../../../dialog.editReportInstanceCommentDialog';
import editReportStatusDialog from '../../../../../dialog.editReportStatusDialog';
import reportInstanceComment from './reportInstanceComment';
import downloadReport from '../../../../../../global/downloadReport';

export default angular.module('app.components.reports.myReports.reportType.reportInstance', [
  loaderService,
  reportsDataService,
  reportsSharedModelService,
  alerts,
  actionIcon,
  viewReport,
  editReportInstanceCommentDialog,
  editReportStatusDialog,
  reportInstanceComment,
  downloadReport
])
  .directive('mrReportInstance', directive)
  .controller('MRReportInstanceController', controller)
  .name;

console.log('app.components.reports.myReports.reportType.reportInstance created');
